import axios from 'axios';
import endPoints from '../const/endPoints';
import convertPayloadToQueryParams from './convertPayloadToQueryParams';
const getAccessToken = async ({ baseURL, authCode, clientId, redirectURI, codeVerifier = sessionStorage.getItem('codeVerifier') }) => {
    const requestBody = {
        code: authCode,
        code_verifier: codeVerifier,
        redirect_uri: redirectURI,
        client_id: clientId,
        grant_type: 'authorization_code'
    };
    return axios.post(`${baseURL}${endPoints.TOKEN}`, convertPayloadToQueryParams(requestBody), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
};
export default getAccessToken;
